import React, { ChangeEvent } from 'react';
import Header from '../../../../widget/header-logo-center/header-logo-center';
import UseCompletePostExpert from '../../../../../controller/account-ctr/complete-create-acount-expert-contributor/use-complete-post-expert';
import useGoBack from '../../../../../hooks/use-navigate';
import { checkIfExist, getSStorage } from '../../../../../utils';
import { Redirect } from 'react-router-dom';

export default function CompletePostExpert() {
  const { postExpert, setPostExpert, navigateCountryExpert } =
    UseCompletePostExpert();
  const { goBack } = useGoBack();

  const sess = getSStorage('businessEmailExpert');

  if (!checkIfExist(sess)) {
    return <Redirect to='/start-expert' />;
  }

  return (
    <div>
      <Header />
      <div className='getstartedContainer'>
        <div className='head-getstarted'>
          <div className='stepInscription'>
            <div className='stepItem done'></div>
            <div className='stepItem done'></div>
            <div className='stepItem done'></div>
            <div className='stepItem done'></div>
            <div className='stepItem'></div>
            <div className='stepItem'></div>
            <div className='stepItem'></div>
          </div>
          <a onClick={goBack} className='link-back'>
            <span className='icon-back'></span>
          </a>
          <h1>Create your account.</h1>
        </div>
        <div className='contentBorder border-top row py-3'>
          <div className='form-group col-12 p-0 m-0 descCompany'>
            <label htmlFor='first-name'>
              If you were to publish a first post to provide value for ISVs,
              what would it be about?
              <div className='d-none'>
                <span className='error-red'> error </span>
                <span className='txt-error'>This field is required</span>
              </div>
            </label>
            <textarea
              maxLength={450}
              value={postExpert}
              onChange={(evt: ChangeEvent<HTMLTextAreaElement>) =>
                setPostExpert(evt.target.value)
              }
            ></textarea>
            <div className='caractercount'>
              {0 + postExpert.length || 0} / 450
            </div>
          </div>
        </div>
        <div className='contentBorder border-top row align-items-stretch'>
          <div className='col-12 d-flex align-items-center pr-0 flex-column'>
            <button
              className='btn btn-devinsider large containerBtnBtn'
              onClick={() => navigateCountryExpert()}
            >
              Next
            </button>
            <a className='skip' onClick={() => navigateCountryExpert()}>
              Skip
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
